import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback } from 'react';
import { ReactSVG } from 'react-svg';
import { propStr } from '../../../helpers/custom-prop-types';
const SvgInline = (props) => {
    const { className, src, wrapperClassName } = props;
    const beforeInjection = useCallback((svg) => {
        // svg.classListはIE11で使用不可のため、setAttributeで対応
        svg.setAttribute('class', clsx('ui-svg-inline', className));
        svg.removeAttribute('style');
    }, [className]);
    return (_jsx(ReactSVG, { beforeInjection: beforeInjection, className: wrapperClassName, src: src }));
};
SvgInline.propTypes = {
    className: propStr(),
    src: propStr().isRequired,
    wrapperClassName: propStr(),
};
SvgInline.defaultProps = {
    className: '',
    wrapperClassName: '',
};
export default SvgInline;
